import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

type ReportFilter = {
  label: string;
  value: string;
};

type ReportPdfConfig = {
  title: string;
  filters?: ReportFilter[];
  columns: string[];
  rows: string[][];
};

const buildReportPdf = ({
  title,
  filters = [],
  columns,
  rows,
}: ReportPdfConfig) => {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });

  doc.setFontSize(16);
  doc.text(title, 40, 40);

  doc.setFontSize(10);
  doc.text(`Generated: ${new Date().toLocaleString()}`, 40, 58);

  let cursorY = 76;
  if (filters.length > 0) {
    const filterText = filters
      .filter((item) => item.value && item.value.trim().length > 0)
      .map((item) => `${item.label}: ${item.value}`)
      .join(" | ");

    if (filterText.length > 0) {
      doc.text(filterText, 40, cursorY);
      cursorY += 18;
    }
  }

  autoTable(doc, {
    startY: cursorY,
    head: [columns],
    body: rows,
    styles: {
      fontSize: 8,
      cellPadding: 4,
    },
    headStyles: {
      fillColor: [31, 41, 55],
      textColor: 255,
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [248, 250, 252],
    },
    margin: { left: 40, right: 40 },
  });

  return doc;
};

export const downloadReportPdf = (
  filename: string,
  config: ReportPdfConfig,
) => {
  const doc = buildReportPdf(config);
  doc.save(filename);
};

export const printReportPdf = (config: ReportPdfConfig) => {
  const doc = buildReportPdf(config);
  doc.autoPrint();
  const blobUrl = doc.output("bloburl");
  window.open(blobUrl, "_blank", "noopener,noreferrer");
};

/**
 * Builds the report PDF and returns it as a base64 data-URI string,
 * suitable for emailing as an attachment.
 */
export const getReportPdfBase64 = (config: ReportPdfConfig): string => {
  const doc = buildReportPdf(config);
  return doc.output("datauristring");
};
